import {
  Chart as ChartJS, CategoryScale, LinearScale,
  PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler,
  LineController, BarController
} from 'chart.js';
import { Chart } from 'react-chartjs-2';


ChartJS.register(CategoryScale, LinearScale, PointElement,
                 LineElement, BarElement, Title, Tooltip, Legend, Filler,
                 LineController, BarController);

function RollingForecastChart({ monthlyData, closedMonths }) {
  if (!monthlyData || monthlyData.length === 0) return null;

  const labels = monthlyData.map(m => m.month.substring(0,3));

  const actualData   = monthlyData.map((m, i) => i < closedMonths ? m.actualNet : null);
  // Forecast: starts at current in-progress month (April) and runs through Dec
  const forecastData = monthlyData.map((m, i) =>
    i >= closedMonths ? m.budgetNet : null
  );
  const budgetData   = monthlyData.map(m => m.budgetNet);

  const data = {
    labels,
    datasets: [
      {
        type:            'bar',
        label:           'Budget',
        data:            budgetData,
        backgroundColor: 'rgba(203,213,225,0.5)',
        borderColor:     '#CBD5E1',
        borderWidth:     1,
        borderRadius:    4,
        order:           2,
      },
      {
        type:            'line',
        label:           'Forecast',
        data:            forecastData,
        borderColor:     '#0E7C7B',
        backgroundColor: 'rgba(14,124,123,0.05)',
        borderWidth:     2,
        borderDash:      [6, 3],
        pointRadius:     3,
        pointBackgroundColor: '#0E7C7B',
        tension:         0.3,
        fill:            true,
        spanGaps:        true,
        order:           1,
      },
      {
        type:            'line',
        label:           'Actual',
        data:            actualData,
        borderColor:     '#1B2A4A',
        backgroundColor: 'rgba(27,42,74,0.08)',
        borderWidth:     2.5,
        pointRadius:     4,
        pointBackgroundColor: '#1B2A4A',
        tension:         0.3,
        fill:            false,
        spanGaps:        false,
        order:           0,
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: {
        position: 'top',
        labels: { boxWidth: 12, font: { size: 12 } },
      },
      tooltip: {
        callbacks: {
          label: ctx => {
            const v = ctx.parsed.y;
            if (v === null) return null;
            const abs = Math.abs(v);
            const str = abs >= 1000 ? `$${(abs/1000).toFixed(1)}k` : `$${abs.toFixed(0)}`;
            return ` ${ctx.dataset.label}: ${v < 0 ? '-' : ''}${str}`;
          }
        }
      }
    },
    scales: {
      y: {
        grid: { color: '#F1F5F9' },
        ticks: {
          callback: v => v >= 1000 ? `$${(v/1000).toFixed(0)}k` : `$${v}`,
          font: { size: 11 },
        }
      },
      x: {
        grid: { display: false },
        ticks: { font: { size: 11 } },
      }
    }
  };

  return (
    <div>
      <div style={{ fontSize:'0.8rem', color:'#64748B', marginBottom:'0.5rem', textAlign:'right' }}>
        <span style={{ color:'#1B2A4A', fontWeight:600 }}>━━</span> Actual &nbsp;
        <span style={{ color:'#0E7C7B' }}>╌╌</span> Forecast &nbsp;
        <span style={{ color:'#CBD5E1', fontWeight:700 }}>▮▮</span> Budget
      </div>
      <Chart type="bar" data={data} options={options} />
      {closedMonths > 0 && (
        <div style={{ fontSize:'0.75rem', color:'#94A3B8', marginTop:'0.5rem', textAlign:'center' }}>
          Jan–{['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][closedMonths-1]} = QB Actuals &nbsp;·&nbsp;
          {['Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','Dec'][closedMonths-1]}–Dec = Forecast
        </div>
      )}
    </div>
  );
}

export default RollingForecastChart;
